import API from "../utility/axios";
const apiUrl = "/api/v2";

export const CREATE_CCAVENUE_PAYMENT = (data: any): Promise<any> => {
  return API.post(`${apiUrl}/initiate/ccavenue/transaction`, data);
};
